import { FilterOptions, OrderOptions, PAGE_DEFAULT, SearchOptions, SearchResult } from './query.model';

export interface SearchOptionsInput {
  filters?: FilterOptions[];
  order?: OrderOptions[];
  pageIndex?: number;
  pageSize?: number;
  abortSignal?: AbortSignal;
}

export function transformToSearchOptions(input: SearchOptionsInput): SearchOptions {
  return {
    criteriaPayload: {
      pageIndex: input.pageIndex ?? PAGE_DEFAULT,
      pageSize: input.pageSize ?? PAGE_DEFAULT,
      filters: input.filters ?? [],
      order: input.order ?? [],
      classifierPayload: { fields: [] },
      classierPayload: { fields: [] }, // TODO will be removed, it is deprecated
    },
    abortSignal: input.abortSignal,
  };
}

export function transformToSearchResult<TResponseItem, TDomain>(
  response: { items: TResponseItem[]; metadata: { totalElements: number } },
  mapItem: (item: TResponseItem) => TDomain,
): SearchResult<TDomain> {
  return {
    items: response.items.map(mapItem),
    totalElements: response.metadata.totalElements,
  };
}
